export default class Toast {
  update(sStorageKey) {
    if (sStorageKey === 'toast') {
      this.addToast();
    }
  }

  addToast() {
    if (!TMON.oApp.htStorage.toast) {
      return;
    }
    const welToastItem = $(
      `<li style="display:list-item">${TMON.oApp.htStorage.toast}</li>`
    );
    $('#toast-ui-wrap ul').append(welToastItem);
    this.removeToast(welToastItem);
  }

  removeToast(el) {
    setTimeout(() => {
      el.remove();
    }, 2000);
  }
}
